import { ErrorList } from "../../../../components/InputTable/InputTable.type";

export const getValidationMessage = (error: ErrorList): string => {
  switch (error.type) {
    case 'limitDaily':
      return `Wartość dobowej liczby przydzielanych rozwiązań GZ do oceny w procesie oceniania musi być większa lub równa jednoczesnej dopuszczalnej liczbie rozwiązań GZ nieodesłanych, jaką może mieć na stanie egzaminator w procesie oceniania
        oraz mniejsza lub równa docelowej liczbie rozwiązań GZ.`;
    case 'limitDesk':
      return `Wartość jednoczesnej dopuszczalnej liczby rozwiązań GZ, które egzaminator ma ocenić w procesie oceniania musi być mniejsza lub równa docelowej liczbie rozwiązań GZ nieodesłanych oraz mniejsza lub równa dobowej liczbie przydzielanych rozwiązań GZ do oceny w procesie oceniania.`;
    case 'limitTotal':
      return 'Wartość docelowej liczby rozwiązań GZ, które egzaminator ma ocenić w procesie oceniania musi być większa lub równa dobowej liczbie przydzielanych rozwiązań GZ do oceny w procesie oceniania oraz większa lub równa jednoczesnej dopuszczalnej liczbie rozwiązań GZ nieodesłanych.';
    case 'extendedAccessDuration':
      return 'Wartość długości okresu przedłużonego dostępu musi być większa lub równa 0.';
    default:
      return '';
  }
};

export const getTooltipTitle = (type: string, value: number | boolean | null) => {
  switch (type) {
    case 'limitDaily':
      return `Sprawdzanie dobowej liczby rozwiązań grup zadań jest teraz ${value ? 'włączone' : 'wyłączone'}`;
    case 'limitDesk':
      return `Sprawdzanie jednoczesnej liczby rozwiązań grup zadań jest teraz ${value ? 'włączone' : 'wyłączone'}`;
    case 'limitTotal':
      return `Sprawdzanie docelowej liczby rozwiązań grup zadań jest teraz ${value ? 'włączone' : 'wyłączone'}`;
    case 'extendedAccessDuration':
      return `Sprawdzanie okresu przedłużonego dostępu jest teraz ${value ? 'włączone' : 'wyłączone'}`;
    default:
      return '';
  }
};

export const getTooltipTitleBlockingLimit = (type: string, value: number | boolean | null, additionalText?: string) => {
  switch(type) {
    case "totalLimitOutOfTolerance":
      return `Całkowity limit poza tolerancją jest teraz ${(value ? "włączony" : "wyłączony")} dla ${additionalText}`; 
    case "sequentialLimitOutOfTolerance":
      return `Sekwencyjny limit poza tolerancją jest teraz ${(value ? "włączony" : "wyłączony")} dla ${additionalText}`;
    case "totalLimitWithinTolerance":
      return `Całkowity limit w zakresie tolerancji jest teraz ${(value ? "włączony" : "wyłączony")} dla ${additionalText}`;
    case "sequentialLimitWithinTolerance":
      return `Sekwencyjny limit w zakresie tolerancji jest teraz ${(value ? "włączony" : "wyłączony")} dla ${additionalText}`;
  }
  return "";
}

export const getTooltipTitleCardLimit = (type: string, value: number | boolean | null, additionalText?: string) => {
  switch(type) {
    case "limitDaily":
      return `Indywidualna dobowa liczba rozwiązań GZ jest teraz ${(value ? "włączona" : "wyłączona")} dla ${additionalText}`; 
    case "limitDesk":
      return `Indywidualna jednoczesna dopuszczalna liczba rozwiązań GZ jest teraz ${(value ? "włączona" : "wyłączona")} dla ${additionalText}`;
    case "limitTotal":
      return `Indywidualna docelowa liczba rozwiązań GZ jest teraz ${(value ? "włączona" : "wyłączona")} dla ${additionalText}`;
  }
  return "";
}